<template>
  <section>
    <yn-list
      name="tasks"
      :data="collection"
      :total="total"
      :skip="skip"
      :size="size"
      :sort="sort"
      :metadata="{
        question: {
          label: 'Question',
          width: '200px'
        },
        text: {
          label: 'Text',
          width: 'minmax(0, 1fr)'
        },
        label: {
          label: 'Label',
          width: '60px'
        },
        confidence: {
          label: 'Confidence',
          width: '85px'
        }
      }"
      :sorting="[
        { id: null, label: 'Most labelled' },
        { id: 'complaint', label: 'Most reported' },
        { id: 'newest', label: 'Newest' },
        { id: 'oldest', label: 'Oldest' }
      ]"
      :actions="[
        { name: 'view', label: '&#10149;', tooltip: 'View this task' },
        { name: 'delete', label: '&times;', tooltip: 'Delete this task' }
      ]"
      :is-request-pending="isRequestPending"
      :is-request-failed="isRequestFailed"
      @delete="remove"
      @view="view"
      @navigate="navigate"
      @sort="setSort"
    >
      <template v-slot:gal="{}"> </template>
      <template v-slot:question="{ value, item }">
        <div class="task-question">
          <div v-if="value" class="">{{ value }}</div>
          <i v-if="Array.isArray(item.audit) && item.audit.find(item => !!item.complaint)" class="task-report">⚑</i>
        </div>
      </template>
      <template v-slot:text="{ value }">
        <div v-if="value" class="task-text">{{ $options.filters.truncate(value, 500) }}</div>
        <div v-else class="task-text empty">Question is empty</div>
      </template>
      <template v-slot:confidence="{ item }">
        <span v-if="Array.isArray(item.audit) && item.audit.length" class="task-audit-confidence">
          {{ (item.audit.filter(({ label }) => label === item.label).length / item.audit.length).toFixed(2) }}
        </span>

        <span class="task-audit-count">({{ item.audit.length }})</span>
      </template>
    </yn-list>
    <yn-audit-modal v-if="!!selectedItem" :item="selectedItem" @close="selectedItem = null"></yn-audit-modal>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import List from './../common/List';
import AuditModal from './AuditModal';

export default {
  components: {
    'yn-list': List,
    'yn-audit-modal': AuditModal
  },
  data() {
    return {
      isReady: true,
      selectedItem: null
    };
  },
  computed: {
    ...mapState({
      collection: s => s.tasks.collection,
      total: s => s.tasks.total,
      size: s => s.tasks.size,
      skip: s => s.tasks.skip,
      sort: s => s.tasks.sort,
      isRequestPending: s => s.tasks.isGetCollectionRequestPending,
      isRequestFailed: s => s.tasks.isGetCollectionRequestFailed
    })
  },
  watch: {
    $route: {
      handler() {
        const params = new URLSearchParams(document.location.search);
        this.$store.dispatch('tasks/getCollection', {
          projectId: this.$route.params.id,
          size: params.get('size') ? +params.get('size') : 25,
          skip: params.get('skip') ? +params.get('skip') : 0,
          sort: params.get('sort') || null
        });
      },
      immediate: true
    }
  },
  methods: {
    async navigate(obj) {
      this.$router.push({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          ...obj
        }
      });
    },
    async remove({ id }) {
      const lock = this.$lock();
      try {
        await this.$store.dispatch('tasks/delete', { id, projectId: this.$route.params.id });

        this.$toast.success({
          title: 'Delete completed',
          message: `Task was deleted.`
        });
      } catch (e) {
        this.$toast.error({
          title: 'Delete failed',
          message: `Please, try again later or contact our development team.`
        });
      } finally {
        lock.release();
      }
    },
    async view(item) {
      this.selectedItem = item;
    },
    async setSort(id) {
      const { sort, ...query } = this.$route.query; // eslint-disable-line

      this.$router.push({
        path: this.$route.path,
        query: {
          ...query,
          ...(id ? { sort: id } : {})
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.topic {
  .task-question {
    font-weight: 300;
    font-style: italic;
    position: relative;
    width: 100%;
    height: 100%;
  }
  .task-text {
    font-weight: 500;
  }

  .empty {
    font-style: italic;
  }

  .task-audit-confidence {
    font-weight: 700;
  }
  .task-audit-count {
    padding: 0 0.25rem;
  }

  .task-report {
    color: var(--theme-error);
    padding: 0 0.25rem;
    font-size: 1rem;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
